import {
    LIST_CUSTOMER_DOCTOR_ASSISTANT
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    customers: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 20
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LIST_CUSTOMER_DOCTOR_ASSISTANT: {
            return {
                ...state,
                customers: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        default: return { ...state };
    }
}
